module.exports = __webpack_public_path__ + "static/media/head_shot.933e0f8e.png";